import React, { useEffect, useState } from "react";
import { Button, Group, Modal, Textarea } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import moment from "moment";
import useStyles from "./style";

const DischargeReasonAndDate = ({
  value,
  setValue,
  row,
  selectedTab,
  disableModalOpen,
  handleDischargeClose,
  reasonError,
  inActiveReason,
  handleDischargeSave,
  setInActiveReason,
  setReasonError,
}) => {
  const [reason, setReason] = useState();

  const { classes } = useStyles();

  useEffect(() => {
    setValue(row?.inactiveClientDate ? row?.inactiveClientDate : new Date());
    setReason(row?.inActiveReason);
    setInActiveReason(row?.inActiveReason);
  }, [row]);
  return (
    <Modal
      centered
      size="md"
      radius="md"
      zIndex={1000}
      overflow="auto"
      onEscClose={false}
      opened={disableModalOpen}
      overlayProps={{ blur: 3 }}
      title="Reason for Discharge"
      onClose={handleDischargeClose}
      // <----- Passing inline css because external css doesnot working. -----> \\
      styles={{
        content: { height: "500px" },
      }}
    >
      {/* <----- Discharge Reason -----> */}
      <Textarea
        required
        autosize
        minRows={3}
        withAsterisk
        maxWidth="300"
        label="Reason"
        error={reasonError}
        value={selectedTab ? inActiveReason : reason}
        placeholder="Reason for Discharge"
        onChange={(e) => {
          setInActiveReason(e.target.value);
          setReason(e.target.value);
          if (e.target.value.trim() !== "") {
            setReasonError("");
          }
        }}
        className={classes.reasonAndDischargeCSS}
      />
      {/* <----- Discharge Date ----->  */}
      {selectedTab === false ? (
        <DateInput
          value={new Date(value)}
          onChange={(date) => setValue(date)}
          label="Discharge Date"
          placeholder={moment().format("MM/DD/YYYY")}
          className={classes.reasonAndDischargeCSS}
        />
      ) : (
        <DateInput
          value={new Date(value)}
          onChange={(date) => setValue(date)}
          label="Discharge Date"
          placeholder={moment().format("MM/DD/YYYY")}
          className={classes.reasonAndDischargeCSS}
        />
      )}
      <Group position="center" mt="md">
        <Button
          size="sm"
          radius="xl"
          color="gray"
          shape="circle"
          variant="outline"
          onClick={handleDischargeClose}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          radius="xl"
          color="red"
          shape="circle"
          onClick={handleDischargeSave}
        >
          Save
        </Button>
      </Group>
    </Modal>
  );
};

export default DischargeReasonAndDate;
